import { AxiosInstance, AxiosResponse } from "axios";
import { ApiPath } from "..";
import { ApiResponse } from "../public-types";
import {
  ModuSignDocument,
  ModuSignDocumentModel,
  ModuSignDocumentPreview,
  ModuSignStartDocumentRequest,
  ModuSignTemplateInfo,
  ModuSignTemplateModel,
} from "./modusign-types";

/**RCS50. 전자계약 서식 목록 조회(모두싸인)*/
export const getModuSignTemplateListAsync = async (
  axios: AxiosInstance,
  contractId?: string,
): Promise<AxiosResponse<ApiResponse<{ templateList: ModuSignTemplateModel }>>> => {
  return await axios.get(ApiPath.contract.moduSign.template.list.replace("{contractId}", contractId!));
};

/**RCS51. 전자계약 템플릿 서식 미리보기(모두싸인)*/
export const getModuSignTemplatePreviewAsync = async (
  axios: AxiosInstance,
  params?: {
    contractId: string;
    templateId: string;
  },
): Promise<AxiosResponse<ApiResponse<{ templateInfo: ModuSignTemplateInfo }>>> => {
  return await axios.get(
    ApiPath.contract.moduSign.template.detail.replace("{contractId}", params?.contractId!).replace("{templateId}", params?.templateId!),
  );
};

/**RCS55. 전자계약 문서 목록 조회(모두싸인)*/
export const getModuSignDocumentListAsync = async (
  axios: AxiosInstance,
  params?: {
    contractId: string;
  },
): Promise<AxiosResponse<ApiResponse<{ documentList: ModuSignDocumentModel }>>> => {
  return await axios.get(ApiPath.contract.moduSign.document.list.replace("{contractId}", params?.contractId!));
};

/**RCS56. 전자계약 문서 상세 조회(모두싸인)*/
export const getModuSignDocumentDetailAsync = async (
  axios: AxiosInstance,
  params?: {
    contractId: string;
    documentId: string;
  },
): Promise<AxiosResponse<ApiResponse<{ documentInfo: ModuSignDocument }>>> => {
  return await axios.get(
    ApiPath.contract.moduSign.document.detail.replace("{contractId}", params?.contractId!).replace("{documentId}", params?.documentId!),
  );
};

/**RCS61. 전자계약 문서 서명요청(모두싸인)*/
export const postModuSignRequestAsync = async (
  axios: AxiosInstance,
  params?: {
    contractId: string;
    startDocument: ModuSignStartDocumentRequest;
  },
): Promise<AxiosResponse<ApiResponse<{ documentInfo: ModuSignDocument }>>> => {
  return await axios.post(ApiPath.contract.moduSign.template.request.replace("{contractId}", params?.contractId!), {
    startDocument: params?.startDocument,
  });
};

/**RCS62. 전자계약 문서 미리보기(모두싸인)*/
export const getModuSignDocumentPreviewAsync = async (
  axios: AxiosInstance,
  params?: {
    contractId: string;
    startDocument: ModuSignStartDocumentRequest;
  },
): Promise<AxiosResponse<ApiResponse<ModuSignDocumentPreview>>> => {
  return await axios.post(ApiPath.contract.moduSign.document.preview.replace("{contractId}", params?.contractId!), {
    startDocument: params?.startDocument,
  });
};

/**RCS63. 진행 중인 문서 서명요청 취소(모두싸인)*/
export const cancelModuSignDocumentAsync = async (
  axios: AxiosInstance,
  params?: {
    contractId: string;
    cancelDocument: {
      id: string;
      message: string;
      accessibleByParticipant?: boolean;
    };
  },
): Promise<AxiosResponse<ApiResponse<{ documentInfo: ModuSignDocument }>>> => {
  return await axios.post(
    ApiPath.contract.moduSign.document.cancel.replace("{contractId}", params?.contractId!).replace("{documentId}", params?.cancelDocument.id!),
    {
      cancelDocument: params?.cancelDocument,
    },
  );
};

/**RCS25. 진행 중인 문서 재전송(이싸인온)*/
export const resendESignOnWorkflowAsync = async (
  axios: AxiosInstance,
  params?: {
    contractId: string;
    workflowId: string;
  },
): Promise<AxiosResponse<ApiResponse<{ resendCount: number }>>> => {
  return await axios.post(
    ApiPath.contract.moduSign.document.resend.replace("{contractId}", params?.contractId!).replace("{workflowId}", params?.workflowId!),
  );
};

/**RCS65. 진행 중인 문서 재전송(모두싸인)*/
export const resendModuSignDocumentAsync = async (
  axios: AxiosInstance,
  params?: {
    contractId: string;
    documentId: string;
  },
): Promise<AxiosResponse<ApiResponse<{ documentInfo: ModuSignDocument }>>> => {
  return await axios.post(
    ApiPath.contract.moduSign.document.resend.replace("{contractId}", params?.contractId!).replace("{documentId}", params?.documentId!),
  );
};
